import React, { useEffect } from "react";
import { useInvalidMediaUploadModalState } from "./InvalidMediaModalState";
import { SELF_CLOSING_MODAL_TIMEOUT_TIME_TO_CLOSE } from "../../ServiceFunctionsModal.types";
import { ModalConstructor } from "../../ModalConstructor";
import {
    ContentTypography,
    ServiceModalInnerContainerStyles,
} from "../ServiceModal.styles";

export function InvalidMediaUploadModal() {
    const { isOpen, setIsOpen, contentText } =
        useInvalidMediaUploadModalState();
    useEffect(() => {
        if (isOpen) {
            const timeout = setTimeout(() => {
                handleClose();
            }, SELF_CLOSING_MODAL_TIMEOUT_TIME_TO_CLOSE);

            return () => {
                clearTimeout(timeout);
            };
        }
    }, [isOpen]);

    const handleClose = () => {
        setIsOpen(false);
    };

    return (
        <ModalConstructor
            onClose={handleClose}
            open={isOpen}
            modalTitle={"Fehler beim Upload!"}
            modalContent={<ContentTypography>{contentText}</ContentTypography>}
            isBorderRadiusVisible={true}
            isInsideClosingButtonVisible={false}
            isOutsideClosingButtonVisible={true}
            modalInnerContainerStyles={ServiceModalInnerContainerStyles}
        />
    );
}
